<template>
    <nav>
        <v-toolbar app dark>
            <v-toolbar-side-icon @click="drawer = !drawer" class="hidden-sm-and-up light-blue--text text--lighten-4"></v-toolbar-side-icon>
            <v-toolbar-title>
                <router-link to="/" tag="span" style="cursor: pointer" class="blue-grey--text text--darken-2">Pense bête</router-link>
            </v-toolbar-title>
            <v-toolbar-items class="hidden-xs-only ml-4">
                <v-btn flat class="light-blue--text text--lighten-4" to="/listes" v-if="userIsAuthenticated">                 
                    <v-icon left>shopping_cart</v-icon>
                    <span>Mes listes</span>
                </v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-xs-only">
                <v-btn flat class="light-blue--text text--lighten-4" to="/enregistrement" v-if="!userIsAuthenticated">
                    <v-icon left>person_pin</v-icon>
                    <span>S'enregistrer</span>
                </v-btn>
                <v-btn flat class="light-blue--text text--lighten-4" to="/connexion" v-if="!userIsAuthenticated">
                    <v-icon left>lock_open</v-icon>
                    <span>Connexion</span>
                </v-btn>
                <v-btn flat class="light-blue--text text--lighten-4" to="/connexion" v-if="userIsAuthenticated" @click="clearUser">
                    <v-icon left>directions_walk</v-icon>
                    <span>Déconnexion</span>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-navigation-drawer v-model="drawer" temporary app dark>
            <v-list>
                <v-list-tile class="hidden-sm-and-up" to="/listes" v-if="userIsAuthenticated">
                    <v-list-tile-action>
                        <v-icon class="light-blue--text text--lighten-4">shopping_cart</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title class="light-blue--text text--lighten-4">Mes listes</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile class="hidden-sm-and-up" to="/enregistrement" v-if="!userIsAuthenticated">
                    <v-list-tile-action>
                        <v-icon class="light-blue--text text--lighten-4">person_pin</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title class="light-blue--text text--lighten-4">S'enregistrer</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile class="hidden-sm-and-up" to="/connexion" v-if="!userIsAuthenticated">
                    <v-list-tile-action>
                        <v-icon class="light-blue--text text--lighten-4">lock_open</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title class="light-blue--text text--lighten-4">Connexion</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile class="hidden-sm-and-up" to="/connexion" v-if="userIsAuthenticated" @click="clearUser">
                    <v-list-tile-action>
                        <v-icon class="light-blue--text text--lighten-4">directions_walk</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title class="light-blue--text text--lighten-4">Déconnexion</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
    </nav>
</template>

<script>
export default {
    data () {
        return {
        drawer: false
        }
    },
    computed: {
        userIsAuthenticated() {
            return this.$store.getters.user !== null && this.$store.getters.user !== undefined
        }
    },
    methods: {
        clearUser() {
            this.$store.dispatch('clearUser')
        }
    }
}
</script>

